import nexus from 'nexus'
import { createProcessObject } from 'redux/helper/objectMapper'

const callLoadProcessData = async processId => {
  const processData = await nexus.process.get(processId)
  return createProcessObject(processData)
}

export default callLoadProcessData
